import { useState } from "react";
import "./ComponentsStyles/CountrySelector.css";
import { setRegion } from "../api/client";

const countries = [
  {
    name: "India",
    code: "IND",
    flag: "https://flagcdn.com/w40/in.png",
  },
  {
    name: "Nepal",
    code: "NP",
    flag: "https://flagpedia.net/data/flags/w1600/np.png",
  },
];

export default function CountrySelector() {
  const [selected, setSelected] = useState(() => {
  const saved = localStorage.getItem("country") || "IND";
  return countries.find((c) => c.code === saved) || countries[0];
});

  const [showDropdown, setShowDropdown] = useState(false);

  const toggleDropdown = () => setShowDropdown(!showDropdown);
 
  // const selectCountry = (country) => {
  //   setSelected(country);
  //   setShowDropdown(false);
  // };

  // const handleRegionSelect = (regionCode) => {
  //   window.location.href = `/home?changeRegion=${regionCode}`;
  // };
   const handleRegionSelect = (regionCode) => {
  // ✅ TEMPORARY: Redirect Nepal to subdomain
  if (regionCode === "NP") {
    window.location.href = "https://np.rbdiagnostic.com";
    return;
  }

  // ✅ Existing flow for India (or others)
  setRegion(regionCode);
  window.location.reload();
};



  return (
    <div className="country-selector">
      <div className="selected" onClick={toggleDropdown}>
        <img src={selected.flag} alt={selected.name} className="flag-img" />
        <span className="arrow">▸</span>
      </div>
      {showDropdown && (
        <ul className="dropdownflag">
          {countries.map((country) => (
            <li
              key={country.code}
              onClick={() => handleRegionSelect(country.code)}
            >
              <img src={country.flag} alt={country.name} className="flag-img" />
              <span className="country-name">{country.name}</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
